import { PageBlockImageReference } from "../elements";
import { z } from "zod";
export const DocumentationLinkPreview = z.object({
    title: z.string().optional(),
    description: z.string().optional(),
    thumbnail: PageBlockImageReference.optional(),
});
